import React from 'react';

const FleetPlan = (props) => {
    return (
        <section className="fleet-copy">
            <div className="row">
                <div className="col-md-10 col-md-offset-1 centered">
                    <div className="inner">
                        <h3 className="mb-5 mt-0">Fleet plan Add-ons</h3>
                        <div className="items-flex flex-wrap">
                            {props.data.data_add_on && props.data.data_add_on.map((item, index) => {                                
                                return (
                                    <div className="plan-container text-center" key={index}>
                                        <h5 className="bold m-0 font-large color-lime" dangerouslySetInnerHTML={{ __html: item.title }} />
                                        <hr />
                                        <p className="price bold mb-0">{item.price}</p>
                                        <small className="m-0">price includes GST</small>
                                        <hr />
                                        <p className="bold m-0">Inclusion:</p>
                                        {item.inclusion.map((item, index) => {
                                            return (
                                                <p key={index} className="m-0 my-2 inclusion" dangerouslySetInnerHTML={{__html: item}} />
                                            )
                                        })}                                        
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default FleetPlan


// WEBPACK FOOTER //
// ./resources/assets/js/modules/mobileFleet/FleetPlan.js